import { Component, Input, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { IAuroraState } from '@apps/aurora.state';
import * as fromRootStore from '@apps/root/store';

@Component({
    selector: 'aa-filter-action-circle2',
    templateUrl: './filter-action-circle2.component.html',
    styleUrls: [
        './filter-action-circle2.component.scss'
    ],
    standalone: false
})
export class FilterActionCircle2Component implements OnInit
{
    @Input() cta: () => void;
    public filterStatus: Observable<boolean> = of(false);

    constructor (
        private store: Store<IAuroraState>
    )
    {
    }

    ngOnInit ()
    {
        // this.store.dispatch(fromRootStore.RootMiscStoreActions.RootFilterStatusSet({
        //     active: false
        // }));
        this.filterStatus = this.store.select(fromRootStore.getFilterStatus);
    }
}
